export default "__VITE_ASSET__RUjT_xv1__"